import React, { useState, useEffect } from 'react'

const UsernameValidator = ({ onChange, currentUsername = '', currentUserId = null }) => {
  const [username, setUsername] = useState(currentUsername)
  const [status, setStatus] = useState(null)
  const [isChecking, setIsChecking] = useState(false)

  useEffect(() => {
    const checkUsername = async () => {
      if (username.length < 3) {
        const newStatus = { type: 'warning', message: 'Username must be at least 3 characters' };
        setStatus(newStatus);
        // Dispatch event for form validation
        const event = new CustomEvent('usernameValidation', {
          detail: { valid: false, username }
        });
        document.dispatchEvent(event);
        return;
      }

      setIsChecking(true);
      try {
        const url = `/users/check_username?username=${encodeURIComponent(username.toLowerCase())}${currentUserId ? `&current_user_id=${currentUserId}` : ''}`;
        const response = await fetch(url);
        const data = await response.json();

        let isValid = false;
        let newStatus;

        if (data.valid) {
          newStatus = { type: 'success', message: 'This username is available!' };
          isValid = true;
        } else {
          newStatus = { type: 'error', message: 'This username is already taken' };
          isValid = false;
        }

        setStatus(newStatus);
        onChange && onChange(username, isValid);

        // Dispatch event for form validation
        const event = new CustomEvent('usernameValidation', {
          detail: { valid: isValid, username }
        });
        document.dispatchEvent(event);

      } catch (error) {
        console.error('Error checking username:', error);
        setStatus({ type: 'error', message: 'Error checking username' });

        // Dispatch event for form validation
        const event = new CustomEvent('usernameValidation', {
          detail: { valid: false, username }
        });
        document.dispatchEvent(event);
      } finally {
        setIsChecking(false);
      }
    }

    const timeoutId = setTimeout(() => {
      if (username) checkUsername()
    }, 500)

    return () => clearTimeout(timeoutId)
  }, [username])

  const getStatusColor = () => {
    switch (status?.type) {
      case 'success': return 'text-green-600'
      case 'error': return 'text-red-600'
      case 'warning': return 'text-yellow-600'
      default: return ''
    }
  }

  return (
    <div className="space-y-2">
      <input
        type="text"
        name="user[username]"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="e.g., CuriousLearner22, MathWhiz2024"
        className="rounded-lg border-gray-300 focus:ring-gray-400 focus:border-gray-400 w-full text-gray-900"
      />
      {status && (
        <div className={`text-sm ${getStatusColor()} flex items-center px-1 py-1`}>
          {isChecking ? (
            <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          ) : status.type === 'success' ? (
            <svg className="h-4 w-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          ) : null}
          {status.message}
        </div>
      )}
      <ul className="text-sm text-gray-500 space-y-0.5 mt-1 pl-1">
        <li>At least 3 characters — letters, numbers, and underscores only</li>
        <li>Visible on leaderboards and shared content</li>
      </ul>
    </div>
  )
}

export default UsernameValidator
